import styled from 'styled-components'
import { Flex } from 'rebass'
import { maxWidth, borders, borderRadius, height, zIndex, boxShadow } from 'styled-system'

const Container = styled(Flex)`
    ${zIndex} ${maxWidth} ${borders} ${borderRadius} ${height} ${boxShadow};
`

Container.defaultProps = {
  maxWidth: 'large',
  flexDirection: 'column',
  borderRadius: 0,
  mx: 'auto',
  zIndex: 0,
  boxShadow: 'none'
}

export default Container
